<p-fieldset [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="report-header">
      <span class="report-title">{{reportsForm.label}}</span>
      <span class="star-wrapper" (click)="$event.stopPropagation(); reportsForm.toggleFavorite()" [title]="reportsForm.isFavorite ? 'Unfavourite this report' : 'Favourite this report'">
        <i class="pi" [class]="reportsForm.isFavorite ? 'pi-star-fill favorite-star' : 'pi-star'"></i>
      </span>
    </div>
  </ng-template>
  <div class="filter-container">
    <div class="filters">
      <app-fy-calender [style]="{ 'min-width': '16rem' }" label="Report Date Range" [isMandatory]="true" (onChange)="onChangeDates($event)" />
    </div>
    <p-button
      styleClass="p-button-outlined"
      label="Generate Report"
      (onClick)="onClickGenerateReport()"
      [loading]="reportsForm.isLoading"
      [disabled]="!canGenerateReport"
    ></p-button>
  </div>
</p-fieldset>
